import { type EcommerceMeta, triggerEcommerceEvent } from 'analytics/events'

import type { MassageState } from '../subflows/massage/types'

export const triggerMultiSelectItemEvent = ({
  massages,
  ecommerceMeta,
}: {
  massages: MassageState[]
  ecommerceMeta: EcommerceMeta
}) => {
  for (const massage of massages) {
    const productId = massage.productNo

    triggerEcommerceEvent({
      event: 'select_item',
      meta: ecommerceMeta,
      items: [
        {
          productId,
          price: massage?.massageInfo?.price,
          quantity: 1,
          index: massage.selectedIndex,
        },
      ],
    })
  }
}
